"use client";

import Link from "next/link";
import { useAuth } from "./AuthProvider";

export default function AuthStatus() {
  const { user, isLoading, logout } = useAuth();

  if (isLoading) {
    return <span className="text-sm text-white/50">Loading...</span>;
  }

  if (!user) {
    return (
      <Link className="text-sm text-white/70 hover:text-white" href="/signin">
        Sign in
      </Link>
    );
  }

  const displayName = user.username?.trim() ? user.username.trim() : user.email;

  return (
    <div className="flex items-center gap-3 text-sm text-white/70">
      <Link className="hover:text-white" href="/account">{displayName}</Link>
      <button
        onClick={() => logout()}
        className="rounded-md border border-white/10 px-2 py-1 text-white/80 hover:text-white"
      >
        Sign out
      </button>
    </div>
  );
}
